/**
 * Define global Vue components here.
 */
export default function defineGlobalComponents(vueContext) {
  vueContext.component(
    'EditInterfaceText',
    require('./modules/interface-text/components/EditInterfaceText.vue').default
  );
  vueContext.component(
    'Translation',
    require('./modules/interface-text/components/Translation.vue').default
  );
}
